import { render, staticRenderFns } from "./SoftFairOffer.vue?vue&type=template&id=79335ab1&"
import script from "./SoftFairOffer.vue?vue&type=script&lang=js&"
export * from "./SoftFairOffer.vue?vue&type=script&lang=js&"
import style0 from "./SoftFairOffer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports